module.exports = __webpack_public_path__ + "static/img/8-g.51c220cf.png";